import {$authHost} from "./index";

const setGuestId = (data) => {
    if (data.guestSessionId) {
        localStorage.setItem('guestSessionId', data.guestSessionId);
    }
};

const DATA_CONSENT_KEY = 'opd_consent_accepted';

const normalizeImagesMeta = (imagesMeta) => {
    if (!Array.isArray(imagesMeta)) return [];

    return [...imagesMeta]
        .sort((a, b) => (a.index ?? 0) - (b.index ?? 0))
        .filter(item => item?.file);
};

// 2. ХОЗЯИН/ГОСТЬ: Отправка последующего сообщения
export const replyMessage = async ({chatSessionId, content, replyTo = null}) => {
    try {
        const {data} = await $authHost.post('api/chat/message/reply', {
            chatSessionId,
            content,
            replyTo
        });

        setGuestId(data);
        return data;
    } catch (e) {
        const msg = e.response?.data?.message || 'Ошибка при отправке сообщения';
        throw new Error(msg);
    }
};

// 2.1. ХОЗЯИН/ГОСТЬ: Отправка сообщения с фото/голосовым
export const replyMessageWithFiles = async ({
                                                chatSessionId,
                                                content = "",
                                                imagesMeta = [],
                                                voiceFile = null,
                                                voiceDurationSec = null,
                                                replyTo = null
                                            }) => {
    try {
        const formData = new FormData();

        formData.append('chatSessionId', chatSessionId);
        formData.append('content', content || '');

        if (replyTo) {
            formData.append('replyTo', JSON.stringify(replyTo));
        }

        const sortedImages = normalizeImagesMeta(imagesMeta);

        sortedImages.forEach((item) => {
            formData.append('images', item.file);
        });

        if (voiceFile) {
            formData.append('voice', voiceFile);
        }

        if (voiceDurationSec) {
            formData.append('voiceDurationSec', voiceDurationSec);
        }

        const {data} = await $authHost.post(
            'api/chat/message/reply/files',
            formData
        );

        setGuestId(data);
        return data;
    } catch (e) {
        const msg = e.response?.data?.message || 'Ошибка при отправке сообщения с файлами';
        throw new Error(msg);
    }
};

// 3. Получение истории чата
export const getChatHistory = async (chatSessionId, params = {}) => {
    try {
        const requestParams = {};

        if (params.limit) {
            requestParams.limit = params.limit;
        }

        if (params.beforeId) {
            requestParams.beforeId = params.beforeId;
        }

        const {data} = await $authHost.get(`api/chat/history/${chatSessionId}`, {
            params: requestParams
        });

        setGuestId(data);

        if (data.session && data.session.opdConsentAccepted) {
            localStorage.setItem(DATA_CONSENT_KEY, 'true');
        } else {
            localStorage.removeItem(DATA_CONSENT_KEY);
        }

        return data;
    } catch (e) {
        const msg = e.response?.data?.message || 'Ошибка при получении истории чата';
        throw new Error(msg);
    }
};

// 4. ХОЗЯИН: Получение всех активных лидов/сессий
export const getOwnerSessions = async () => {
    try {
        const {data} = await $authHost.get('api/chat/sessions/owner');
        setGuestId(data);
        return data;
    } catch (e) {
        const msg = e.response?.data?.message || 'Ошибка при получении сессий владельца';
        throw new Error(msg);
    }
};

// 1. Создание чата
export const createOrGetChat = async (addId) => {
    const {data} = await $authHost.post('/api/chat/createOrGet', {addId});
    setGuestId(data);
    return data;
};

// 5. Установка сообщений в статус "Прочитано"
export const readMessages = async (chatSessionId) => {
    try {
        const { data } = await $authHost.post('api/chat/readMessages', { chatSessionId });
        return data;
    } catch (e) {
        console.error("Ошибка при пометке сообщений как прочитанных:", e.response?.data?.message || e.message);
        throw e;
    }
};

// 6. Запись согласия на обработку персональных данных (ОПД)
export const recordOPDConsent = async (chatSessionId) => {
    try {
        const {data} = await $authHost.post('api/chat/consent', {chatSessionId});

        localStorage.setItem(DATA_CONSENT_KEY, 'true');

        setGuestId(data);

        return data;
    } catch (e) {
        const msg = e.response?.data?.message || 'Ошибка сервера при фиксации согласия ОПД.';
        throw new Error(msg);
    }
};

// ADMIN
export const getAdminChatSessions = async ({ page = 1, limit = 30, search = '' } = {}) => {
    const { data } = await $authHost.get('api/chat/admin/sessions', {
        params: { page, limit, search }
    });
    return data;
};

export const getAdminChatHistory = async (chatSessionId) => {
    const { data } = await $authHost.get(`api/chat/admin/history/${chatSessionId}`);
    return data;
};